<template>
  <a
    class="terms-link"
    href="/agb.html"
    target="_blank"
    rel="noopener noreferrer"
    @click.stop
  >
    {{ linkText }}
  </a>
</template>

<script>
export default {
  name: 'TermsAndConditions',
  props: {
    linkText: {
      type: String,
      default: 'Allgemeine Geschäftsbedingungen'
    }
  }
}
</script>

<style scoped>
.terms-link {
  text-decoration: underline;
  cursor: pointer;
  color: inherit;
  font-weight: 500;
}

.terms-link:hover {
  opacity: 0.7;
}
</style>
